// libraries
import { fromString } from "../../../../libraries/EnhancedDate";

// helpers
import bookingEstimateHasAdvance from "../../../booking/estimate/hasAdvance";

/**
 * Retourne les informations à afficher pour la demande d'accompte.
 */
export default function bookingEstimateGetAdvance({ bookingEstimate }) {
  if (!bookingEstimateHasAdvance({ bookingEstimate })) {
    return null;
  }

  return {
    maxDueDate: fromString(
      bookingEstimate.advanceMaxDueDate,
      "Y-m-d"
    ).getNativeDate(),
    amount: bookingEstimate.advanceAmount,
  };
}
